import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {MomentDateRange} from './moment-date-range';
import {PredefinedInterval} from './predefined-interval';
import {DateIntervalService} from '../date-interval-service/date-interval.service';

@Component({
  selector: 'app-date-interval',
  templateUrl: './date-interval.component.html',
})
export class DateIntervalComponent implements OnInit, OnDestroy {
  @Output() dateRangeChanged: EventEmitter<MomentDateRange>;
  subscriptions: Array<Subscription> = [];

  constructor(
    public dateIntervalService: DateIntervalService) {
    this.dateRangeChanged = new EventEmitter<MomentDateRange>();
  }

  ngOnInit() {
    this.subscriptions.push(this.dateIntervalService.dateRange.subscribe(
      dateRange => this.dateRangeChanged.emit(dateRange)
    ));
  }

  ngOnDestroy() {
    this.subscriptions
      .filter(s => !!s)
      .forEach(s => {
        s.unsubscribe();
      });
  }

  intervalClick(interval: PredefinedInterval) {
    this.dateIntervalService.dateRange.next([
      interval.from, interval.to
    ]);
  }

  intervalIsSelected(interval: PredefinedInterval, dateRange: MomentDateRange) {
    return interval.from.format('YYYY-MM-DD') === dateRange[0].format('YYYY-MM-DD')
      && interval.to.format('YYYY-MM-DD') === dateRange[1].format('YYYY-MM-DD');
  }

  onDateTimeChange(event) {
    this.dateIntervalService.dateRange.next(event.value);
  }
}
